import type { HTMLAttributes, ReactElement } from 'react';

import { SizeNames } from '@/types';
import {
  StyledCircleMask,
  StyledIcon,
  StyledMaskContainer,
} from './Mask.styles';

export type Sizes = Record<
  SizeNames,
  {
    width: string;
    height: string;
  }
>;

export interface MaskProps extends HTMLAttributes<HTMLDivElement> {
  raised?: boolean;
  border?: boolean;
  background?: string;
  size?: keyof Sizes;
  icon?: ReactElement;
  iconDimension?: string;
}

const Sizes = {
  extraSmall: {
    width: '100px',
    height: '100px',
  },
  small: {
    width: '134px',
    height: '134px',
  },
  medium: {
    width: '165px',
    height: '165px',
  },
  large: {
    width: '258px',
    height: '258px',
  },
};

const Mask = ({
  children,
  icon,
  border,
  raised,
  background,
  size = 'medium',
  iconDimension,
  ...restProps
}: MaskProps) => {
  const { width, height } = Sizes[size];

  return (
    <StyledMaskContainer
      width={iconDimension ?? width}
      height={iconDimension ?? height}
      {...restProps}
    >
      <StyledCircleMask border={border} raised={raised} background={background}>
        {children}
      </StyledCircleMask>
      <StyledIcon width={iconDimension ?? width}>{icon}</StyledIcon>
    </StyledMaskContainer>
  );
};

export default Mask;
